import React from 'react'
import { useTranslation } from 'react-i18next'
import { AppUrls } from 'common/AppUrls'
import { PageHeaderWithButtons } from 'components/shared'
import { HelpConfig } from './config/HelpConfig'
import './Help.scss'

export const Help = () => {
    const { t } = useTranslation()

    return (
        <>
            <PageHeaderWithButtons backUrl={AppUrls.settings} pageName={t('help')} />
            {HelpConfig.map(({ id, name, icon }) => (
                <div key={id} className="help__item d-flex align-items-center">
                    {icon}
                    <span>{t(`help_items.${name}`)}</span>
                </div>
            ))}
        </>
    )
}
